import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ModalModule } from 'ngx-bootstrap/modal';

import { HierarchyCommonModule } from '®shared/hierarchy';
import { TrapFocusModule } from '®shared/trap-focus';

import { ListNodesModule } from '../common';

import { NodeSearchFieldComponent } from './node-search-field.component';
import { NodeSearchEffects } from './node-search.effects';
import { NodesEditorModalComponent } from './nodes-editor-modal.component';
import { NodesEditorModalEffects } from './nodes-editor-modal.effects';
import { NodesEditorComponent } from './nodes-editor.component';
import { nodesEditorReducer } from './nodes-editor.reducer';
import {
  STATE_FEATURE_NODES_EDITOR,
  getInitialNodesEditorState,
} from './nodes-editor.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([NodesEditorModalEffects, NodeSearchEffects]),
    HierarchyCommonModule,
    ListNodesModule,
    MatAutocompleteModule,
    MatInputModule,
    ModalModule,
    ReactiveFormsModule,
    StoreModule.forFeature(STATE_FEATURE_NODES_EDITOR, nodesEditorReducer, {
      initialState: getInitialNodesEditorState,
    }),
    TrapFocusModule,
  ],
  declarations: [
    NodeSearchFieldComponent,
    NodesEditorComponent,
    NodesEditorModalComponent,
  ],
  exports: [
    NodeSearchFieldComponent,
    NodesEditorComponent,
    NodesEditorModalComponent,
  ],
})
export class NodesEditorModule {}
